import 'react-ace';
require('ace-builds/src-noconflict/mode-sql');
const WIN: any = window;

export class CustomHighlightRules extends WIN.ace.acequire(
  'ace/mode/text_highlight_rules'
).TextHighlightRules {
  constructor() {
    super();

    const keywords =
      'find|with|where|that|and|or|order|by|limit|skip|as|return|asc|desc|tree|relates|to';

    const builtinConstants = 'true|false|undefined|null|date.now';

    const builtinFunctions = 'avg|count|max|min|sum|date';

    const keywordMapper = this.createKeywordMapper(
      {
        'support.function': builtinFunctions,
        keyword: keywords,
        'constant.language': builtinConstants,
      },
      'identifier',
      true
    );

    (this as any).$rules = {
      start: [
        {
          token: 'string', // " string
          regex: '".*?"',
        },
        {
          token: 'string', // ' string
          regex: "'.*?'",
        },
        {
          token: 'string', // ` string (apache drill)
          regex: '`.*?`',
        },
        {
          token: 'constant.numeric', // float
          regex: '[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b',
        },
        {
          token: keywordMapper,
          regex: '[a-zA-Z_$][a-zA-Z0-9_$]*\\b',
        },
        {
          token: 'keyword.operator',
          regex: '\\+|\\-|\\/|\\/\\/|%|&|\\^|~|<|>|<=|=>|==|!=|<>|=',
        },
        {
          token: 'paren.lparen',
          regex: '[\\(]',
        },
        {
          token: 'paren.rparen',
          regex: '[\\)]',
        },
        {
          token: 'text',
          regex: '\\s+',
        },
      ],
    };
    this.normalizeRules();
  }
}

export default class J1QLMode extends WIN.ace.acequire('ace/mode/sql').Mode {
  constructor() {
    super();
    (this as any).HighlightRules = CustomHighlightRules;
  }
}
